<template>
    <div :class="{ 'bg-purple ppv2-bg-opacity-10 p-4 rounded-4': isHighlighted }">
        <div
            class="fw-bold text-uppercase tracking-wider mb-3 d-flex align-items-center gap-2"
            :style="{ color: '#7d2dbd', fontSize: '0.85rem' }"
        >
            <span v-if="isHighlighted">★</span> {{ title }}
        </div>

        <div class="d-flex flex-column gap-3 ppv2-p-1">
            <div
                v-for="widget in widgets"
                :key="widget.id"
                class="ppv2-bg-white dark:ppv2-bg-dark p-3 d-flex align-items-center clickable-card"
                :class="[
                    isHighlighted
                        ? 'rounded-4'
                        : 'rounded-3 ppv2-border ppv2-border-solid ppv2-border-black ppv2-border-opacity-20 position-relative',
                    { 'active-card-style': selectedWidgetId === widget.id },
                ]"
                @click="$emit('select', widget)"
            >
                <div
                    class="icon-box bg-purple ppv2-bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center me-3"
                >
                    <component :is="widget.iconName" :size="20" :stroke-width="2" />
                </div>

                <div class="flex-grow-1 pe-4">
                    <h4
                        class="poppinsSemiBold ppv2-text-black ppv2-opacity-80 ppv2-mb-2"
                        :style="{ fontSize: normalizeFontSize(15) }"
                    >
                        {{ widget.title }}
                    </h4>
                    <p
                        class="ppv2-mb-0 ppv2-text-black ppv2-text-opacity-70"
                        :style="{ fontSize: normalizeFontSize(13) }"
                        style="max-width: 270px; line-height: 1.65"
                    >
                        {{ widget.description }}
                    </p>
                </div>

                <div class="arrow-badge rounded-3 d-flex align-items-center justify-content-center ms-auto">
                    <component :is="'ArrowRight'" :size="16" :stroke-width="2.5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import normalizeFontSize from '../../../utils/normalizeFontSize.js'

import {
    LayoutGrid,
    Layers,
    Gift,
    Calendar,
    CreditCard,
    RefreshCw,
    Tag,
    ShoppingCart,
    FileText,
    Utensils,
    ArrowRight,
    Sparkles,
    Ticket,
    User,
} from 'lucide-vue'
export default {
    name: 'WidgetCategory',
    components: {
        LayoutGrid,
        Layers,
        Gift,
        Calendar,
        CreditCard,
        RefreshCw,
        Tag,
        ShoppingCart,
        FileText,
        Utensils,
        ArrowRight,
        Sparkles,
        Ticket,
        User,
    },
    props: {
        title: { type: String, required: true },
        widgets: { type: Array, required: true },
        selectedWidgetId: { type: [String, Number], default: null },
        isHighlighted: { type: Boolean, default: false },
    },
    methods: {
        normalizeFontSize,
    },
}
</script>

<style scoped>
.clickable-card {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

.icon-box {
    width: 48px;
    height: 48px;
    color: #7d2dbd;
    transition: all 0.2s ease-in-out;
}

.arrow-badge {
    width: 32px;
    height: 32px;
    background-color: transparent;
    color: #a0aec0;
    transition: all 0.2s ease-in-out;
}

.clickable-card:hover,
.clickable-card.active-card-style {
    border-color: #7d2dbd !important;
    background-color: #7d2dbd20 !important;
}

.clickable-card:hover .icon-box,
.clickable-card.active-card-style .icon-box {
    background-color: #7d2dbd !important;
    color: #ffffff !important;
}

.clickable-card:hover .arrow-badge,
.clickable-card.active-card-style .arrow-badge {
    background-color: #7d2dbd20 !important;
    color: #7d2dbd !important;
    box-shadow: 0 2px 6px rgba(125, 45, 189, 0.08);
}
</style>
